import {HttpClient} from "../../service/httpClient/HttpClient";

export class DashboardService {
    constructor() {
        this.httpClient = new HttpClient()
    }


    getDashboardReports(fundID) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `funds/${fundID}/dashboard-information`
            ).then(resolve).catch(reject)
        })
    }
}